import React from 'react'
import { FaHtml5, FaCss3, FaJs } from 'react-icons/fa'
import { DiRuby } from "react-icons/di";
import { SiPostgresql, SiRails, SiReact } from "react-icons/si";





let left = '0'
let right = '50%'
let width = '190%'
let heightt = (window.screen.width/800)*1800 +'px'
let svgWidth = 2000
if (window.screen.width>1200) {
    left = '50%'
    right = 800*(window.screen.width/1000)+'px'
    width = 2000*(window.screen.width/1000)+'px'
    heightt = 1800*(window.screen.width/1000)+'px'
    // svgWidth = 2400*(window.screen.width/1400)
    svgWidth = 2400
}

const styles = { height: heightt, fontSize:'0', position: 'relative', left: left, bottom: '-10px'}
const styles2 = { height: heightt, textAlign:'center', position: 'relative', right: right, fontSize:'0'}
const textStyles = {fill: '#9EFFC8', backgroundColor: "white", 
fontSize: '40', fontFamily: 'Nanum Gothic Coding'}



let backGroundArr = [
    [[-1500, 1500]],
    [[-1500, 1700]],
    [[2400, 1700]],
    [[1900, 1000]],
    [[900, 1000]],
    [[900, 1300]],
    [[200, 200], [0, 1], [500, 1300],[0]],
    [[500, 1300]],
    [[300, 1300]],
    [[300, 300], [0, 1], [-100, 1500], [0]],
    [[-100, 1500]],
    [[-1500, 1500]]
]

let backGround = ''











let hFace = 400


let faceBlock1Arr = [[[300, hFace+0]], 
[[550, hFace+0]], 
[[550, hFace+275]], 
[[350, hFace+275]], 
[[10, 10], [0, 0], [350, hFace+500], [0]], 
[[350, hFace+500]], 
[[600, hFace+500]], 
[[600, hFace+800]], 
[[200, 150], [0, 1], [100, hFace+800], [0]], 
[[100, hFace+800]], 
[[100, hFace+350]], 
[[200, hFace+350]], 
[[200, hFace+125]], 
[[300, hFace+125]]]

let faceBlock1 = ''
let facescale = 1.1

for (let i=0; i<faceBlock1Arr.length; i++) {
    if (faceBlock1Arr[i].length === 1) {
        faceBlock1Arr[i][0][0] = (faceBlock1Arr[i][0][0] - 355)*facescale + 355 + 20
        faceBlock1Arr[i][0][1] = (faceBlock1Arr[i][0][1] - 920)*facescale + 920
    } else if (faceBlock1Arr[i].length === 4) {
        faceBlock1Arr[i][0][0] = (faceBlock1Arr[i][0][0])*facescale
        faceBlock1Arr[i][0][1] = (faceBlock1Arr[i][0][1])*facescale
        faceBlock1Arr[i][2][0] = (faceBlock1Arr[i][2][0] - 355)*facescale + 355 + 20
        faceBlock1Arr[i][2][1] = (faceBlock1Arr[i][2][1] - 920)*facescale + 920
    }
}









let eyesArr = [
[[410, hFace+0]], 
[[230, 230], [0, 1], [460, hFace+170], [0]],
[[230, 230], [0, 1], [410, hFace+0], [0]],
[],
[[570, hFace-20]], 
[[230, 230], [0, 1], [560, hFace+130], [0]],
[[230, 230], [0, 1], [570, hFace-20], [0]]
]
let eyes = ''


let pupilsArr = [
    [[430, 52 + hFace]],
    [[1, 1], [1, 0], [410, 52 + hFace], [0]],
    [],
    [[430, 52 + hFace]],
    [[1, 1], [0, 1], [410, 52 + hFace], [0]],
    [],
    [[575, 52 + hFace]],
    [[1, 1], [1, 0], [555, 52 + hFace], [0]],
    [],
    [[575, 52 + hFace]],
    [[1, 1], [0, 1], [555, 52 + hFace], [0]]
]

let pupils = ''






let noseArr = [[[580, hFace+100]], 
[[680, hFace+200]],
[[580, hFace+200]]
]

let nose = ''








let aboutArr = [[[270, 110]], 
[[270, 100]], 
[[100, 150],[0, 1], [300, 0], [0]], 
[[300, 110]], 
[], 
[[275, 50]], 
[[300, 50]], 
[],
[[320, 20]], 
[[320, 120]], 
[[340, 120]]]

let about = ''




let scale = 1.3
let v = 100
let bubbleArr = [[[370, 60]], 
[[50, 60], [0, 1], [420, 0], [0]], 
[[660, 0]], [[40, 40], [0, 1], [690, 42], [0]],
[[730 + v, 42]], [[120, 145], [0, 1], [850 + v, 195], [0]],
[[850 + v, 530]], [[70, 68], [0, 1], [780 + v, 600], [0]],
[[640 + v, 600]], [[20, 20], [0, 0], [620 + v, 620], [0]],
[[620 + v, 724]], [[20, 20], [0, 1], [600 + v, 744], [0]],
[[590 + v, 744]], [[10, 10], [0, 0], [580 + v, 754], [0]], 
[[580 + v, 850]], [[20, 20], [0, 1], [560 + v, 870], [0]],
[[368, 870]], 
[[8, 11], [0, 0], [360, 878], [0]],
[[360, 920]], 
[[355, 920]],
[[355, 860]], 
[[16, 20], [0, 1], [375, 840], [0]],
[[375, 840], [460, 870], [520 + v, 850]],
[[520 + v, 850]], [[45, 35], [0, 0], [560 + v, 820], [0]],
[[560 + v, 830],[570 + v, 790], [550 + v, 735]],
[[550 + v, 735]], [[30, 30], [0, 1], [570 + v, 694], [0]],
[[580 + v, 694]], [[7, 7], [0, 0], [585 + v, 688], [0]],
[[585 + v, 670]], [[7, 7], [0, 0], [578 + v, 662], [0]],
[[550 + v, 662]], [[25, 25], [0, 1], [530 + v, 642], [0]],
[[530 + v, 605]], [[25, 25], [0, 1], [550 + v, 585], [0]], 
[[680 + v, 585]], [[20, 20], [0, 0], [700 + v, 565], [0]],
[[700 + v, 440]], [[70, 70], [0, 0], [630 + v, 366], [0]],
[[360, 366]], [[80, 70], [0, 1], [270, 300], [0]],
[[270, 250]], [[50, 50], [0, 1], [310, 200], [0]],
[[350, 200]], [[20, 20], [0, 0], [370, 180], [0]]]

let bubble = ''












for (let i=0; i<bubbleArr.length; i++) {
    if (bubbleArr[i].length === 1) {
        bubbleArr[i][0][0] = (bubbleArr[i][0][0] - 355)*scale + 355
        bubbleArr[i][0][1] = (bubbleArr[i][0][1] - 920)*scale + 920
    } else if (bubbleArr[i].length === 3) {
        bubbleArr[i][0][0] = (bubbleArr[i][0][0] - 355)*scale + 355
        bubbleArr[i][0][1] = (bubbleArr[i][0][1] - 920)*scale + 920
        bubbleArr[i][1][0] = (bubbleArr[i][1][0] - 355)*scale + 355
        bubbleArr[i][1][1] = (bubbleArr[i][1][1] - 920)*scale + 920
        bubbleArr[i][2][0] = (bubbleArr[i][2][0] - 355)*scale + 355
        bubbleArr[i][2][1] = (bubbleArr[i][2][1] - 920)*scale + 920
    } else if (bubbleArr[i].length === 4) {
        bubbleArr[i][0][0] = (bubbleArr[i][0][0])*scale
        bubbleArr[i][0][1] = (bubbleArr[i][0][1])*scale
        bubbleArr[i][2][0] = (bubbleArr[i][2][0] - 355)*scale + 355
        bubbleArr[i][2][1] = (bubbleArr[i][2][1] - 920)*scale + 920
    }
}







let bubble2Arr = [[[370, 60]], 
[[50, 60], [0, 1], [420, 0], [0]], 
[[660, 0]], [[40, 40], [0, 1], [690, 42], [0]],
[[730 + v, 42]], [[120, 145], [0, 1], [850 + v, 195], [0]],
[[850 + v, 530]], [[70, 68], [0, 1], [780 + v, 600], [0]],
[[640 + v, 600]], [[20, 20], [0, 0], [620 + v, 620], [0]],//
[[620 + v, 724]], [[20, 20], [0, 1], [600 + v, 744], [0]],
[[590 + v, 744]], [[10, 10], [0, 0], [580 + v, 754], [0]], 
[[580 + v, 850]], [[20, 20], [0, 1], [560 + v, 870], [0]],
[[368, 870]], 
[[8, 11], [0, 0], [360, 878], [0]],
[[360, 920]], 
[[355, 920]],
[[355, 860]], 
[[16, 20], [0, 1], [375, 840], [0]],
[[375, 840], [460, 870], [520 + v, 850]],
[[520 + v, 850]], [[45, 35], [0, 0], [560 + v, 820], [0]],
[[560 + v, 830],[570 + v, 790], [550 + v, 735]],
[[550 + v, 735]], [[30, 30], [0, 1], [570 + v, 694], [0]],
[[580 + v, 694]], [[7, 7], [0, 0], [585 + v, 688], [0]],
[[585 + v, 670]], [[7, 7], [0, 0], [578 + v, 662], [0]],
[[550 + v, 662]], [[25, 25], [0, 1], [530 + v, 642], [0]],
[[530 + v, 605]], [[25, 25], [0, 1], [550 + v, 585], [0]], 
[[680 + v, 585]], [[20, 20], [0, 0], [700 + v, 565], [0]],
[[700 + v, 440]], [[70, 70], [0, 0], [630 + v, 366], [0]],//
[[360, 366]], [[80, 70], [0, 1], [270, 300], [0]],
[[270, 250]], [[50, 50], [0, 1], [310, 200], [0]],
[[350, 200]], [[20, 20], [0, 0], [370, 180], [0]]]




let bubble2 = ''











let shapesArr = [[faceBlock1Arr, faceBlock1], 
[aboutArr, about], 
[bubbleArr, bubble], 
[bubble2Arr, bubble2], 
[eyesArr, eyes], 
[pupilsArr, pupils],
[noseArr, nose],
[backGroundArr, backGround]]


for (let j=0; j < shapesArr.length; j++) {
    for (let i=0; i < shapesArr[j][0].length; i++) {
        if (i === 0) {
            shapesArr[j][1] = shapesArr[j][1] + 'M' + shapesArr[j][0][0][0][0] + ' ' + shapesArr[j][0][0][0][1] + ' '
        } else {
            if (shapesArr[j][0][i].length === 0) {
                shapesArr[j][1] = shapesArr[j][1] + 'M' + shapesArr[j][0][i + 1][0][0] + ' ' + shapesArr[j][0][i + 1][0][1] + ' '
            }
            else if(shapesArr[j][0][i].length === 1) {
                shapesArr[j][1] = shapesArr[j][1] + 'L' + shapesArr[j][0][i][0][0] + ' ' + shapesArr[j][0][i][0][1] + ' '
            } else if (shapesArr[j][0][i].length === 3) {
                shapesArr[j][1] = shapesArr[j][1] + ' Q' + shapesArr[j][0][i][1][0] + ' ' + shapesArr[j][0][i][1][1] + ' ' + shapesArr[j][0][i][2][0] + ' ' + shapesArr[j][0][i][2][1] + ' '
            } else if (shapesArr[j][0][i].length === 4) {
                shapesArr[j][1] = shapesArr[j][1] + 'A' + shapesArr[j][0][i][0][0] + ' ' + shapesArr[j][0][i][0][1] + ' ' + shapesArr[j][0][i][3] + ' ' + shapesArr[j][0][i][1][0] + ' ' + shapesArr[j][0][i][1][1] + ' ' + shapesArr[j][0][i][2][0] + ' ' + shapesArr[j][0][i][2][1] + ' '
            }
        }

    }
    
}

shapesArr[0][1] = shapesArr[0][1] + 'Z'
shapesArr[2][1] = shapesArr[2][1] + 'Z'
shapesArr[3][1] = shapesArr[3][1] + 'Z'




console.log()



const About = () => {

    
    return (

        <div style={styles}>
            <div style={styles2}>
            

                <svg viewBox={'-450 -400 ' + svgWidth + ' 1800'}  style={{ overflow:'hidden', position:'relative', left: '0px', fontSize: '0'}} width={width} height={heightt}>

                    <path id='backGround2' d={'M-800 100  L1500 100  L1500 1750  L-800 1750'} fill={'#E1BDEC'} stroke={'#343249'} strokeWidth={'0'}/>
                    <path id='backGround' d={shapesArr[7][1]} fill={'#343249'} stroke={'#343249'} strokeWidth={'0'}/>
                    {/* <path id='bgTriangle' d={'M450 700 L500 750 L400 750'} fill={'#BFF429'} stroke={'#343249'} strokeWidth={'0'}/> */}





                    <path id='about' d={shapesArr[1][1]} fill={'none'} stroke={'white'} strokeWidth={'2'}/>

                    <path id='bubble2' d={shapesArr[3][1]} fill={'#FFBBF8'} stroke={'pink'} strokeWidth={'5'}/>
                    <path id='bubble' d={shapesArr[2][1]} fill={'#FC94FF'} stroke={'pink'} strokeWidth={'5'}/>

                    <path id='nose' d={shapesArr[6][1]} fill={'red'} stroke={'red'} strokeWidth={'2'}/>
                    <path id='faceBlock1' d={shapesArr[0][1]} fill={'#DD062F'} stroke={'none'}/>
                    <path id='eyes' d={shapesArr[4][1]} fill={'white'} stroke={'pink'} strokeWidth={'4'}/>
                    <path id='pupils' d={shapesArr[5][1]} fill={'black'} stroke={'pink'} strokeWidth={'4'}/>
                    


      

                    {/* <path id={'test'} d={"M450 800 Q525 700 500 800   M500 800 Q450 1000 600 800  M600 800 Q750 600 700 800      M759 800 Q823 1200 900 0  M900 0 Q991 400 1100 0"} fill={'none'} stroke={'black'} strokeWidth={'2'}/> */}
                    {/* <path id={'test'} style={{transform: 'rotateX(0deg)'}} d={"M450 800 Q525 700 500 800   M500 800 Q450 1000 600 800  M600 800 Q750 600 700 800      M700 800 Q600 1200 900 800  M900 800 Q1200 400 1100 800"} fill={'none'} stroke={'pink'} strokeWidth={'2'}/> */}
                    {/* <path id={'test'} style={{transform: 'rotateY(40deg) perspective(1000px)', transformOrigin: '400px 800px'}} d={"M300 800 Q200 1200 500 800  M500 800 Q800 400 700 800     M700 800 Q600 1200 900 800  M900 800 Q1200 400 1100 800"} fill={'none'} stroke={'pink'} strokeWidth={'2'}/> */}
                    {/* <animate 
                       href={"#test"}
                        attributeName={"d"}
                        from={"M100 900 Q600 400 1100 900"}
                        to={"M900 900 Q1400 400 1900 900"}
                        dur={"2s"}
                        begin={"0s"}
                        repeatCount={"indefinite"}
                    /> */}

                    <text style={textStyles} x="400" y="-180" >
                        <tspan x="400" y="-220">Recent graduate</tspan>
                        <tspan x="450" y="-170">from</tspan>
                        <tspan x="400" y="-120">Coder Academy</tspan>
                        <tspan style={{fill:'white', fontSize:'120'}} x="700" y="-130">I</tspan>
                        <tspan style={{fill:'white', fontSize:'120'}} x="730" y="-70">AM</tspan>
                        <textPath href={"#curve"} style={{ fontFamily: 'Rock Salt', fill: '#FB5100', fontSize:'100'}} x="400" y="10">CREATIVE</textPath>
                        <tspan style={{fill:'white', fontSize:'200'}} x="280" y="140">&</tspan>
                        <tspan style={{fontFamily: 'Chakra Petch', fill:'#79FF77', fontSize:'90'}} x="440" y="140">ANALYTICAL</tspan>

                        <tspan style={{fill:'white', fontSize:'60'}} x="1035" y="-130">I</tspan>
                        <tspan style={{writingMode: 'vertical-rl', textOrientation: 'upright', fill: '#CB2EFF', fontFamily: 'Creepster', fontSize: '50'}} x="1050" y="-100">CONSUME</tspan>
                        <tspan style={{fontSize:'100'}} x="990" y="390">TE</tspan>
                        <tspan style={{fontSize:'100'}} x="990" y="460">CH</tspan>
                    
                    </text>
                    
    

                    <path id='curve' d={'M400 80 Q470 0 640 50 Q760 100 1200 -50'} fill={'none'} stroke={'black'} strokeWidth={'0'}/>



                    {/* <path id='gut' d={'M350 930 L350 900 L350 900 L370 900 L370 950  A 25 25 0 0 0 390 970'
                        + 'A 90 150 0 0 1 490 970   A 22 25 0 0 1 370 1100   A 25 25 0 0 0 355 1120   L355 1140'
                        + 'L335 1140 L335 1120   A 42 42 0 0 1 370 1080' 
                        + 'A 30 30 0 0 1 390 1050   A 60 30 0 0 0 390 1030'
                        + 'A 30 30 0 0 0 380 1020   A 30 30 0 0 1 375 990' 
                        + 'A 40 40 0 0 1 350 952'
                        + 'L350 930'

                        + 'M300 1290  L190 1320' 
                        + 'L190 1290'
                        + 'L200 1170'
                        + 'L250 1130'
                        + 'L350 1140'
                        + 'L500 1110'
                        + 'L490 1230'
                        + 'L515 1320'
                        + 'L480 1340'
                        + 'L390 1320'
                        + 'L390 1350'
                        + 'L350 1350'
                        + 'L350 1290'
                        + 'L380 1260'
                        + 'L430 1270'
                        + 'L420 1210'} fill={'pink'} stroke={'red'} strokeWidth={'2'}/> */}

                    <path id='gut' d={'M350 930   L350 904   L350 904   L370 904   L370 950  A 25 25 0 0 0 390 970'
                        + 'A 110 110 0 0 1 490 1100   A 31 25 0 0 1 220 1370   A 114 120 0 0 1 300 1150'
                        
                        + 'A 30 20 0 0 0 335 1120  ' 
                        + 'A 40 40 0 0 1 350 952'
                        + 'L350 930'} 
                    fill={'#FFD515'} stroke={'pink'} strokeWidth={'9'}/>

                    <path id='acid' d={'M476 1075 '
                        + ' A 50 50 0 0 1 470 1114  A 200 149 0 0 1 545 1255'  
                        + ' A 190 150 0 0 1 350 1385   A 170 120 0 0 1 210 1210   A 108 113 10 0 1 320 1170'
                        
                        + ' A 65 45 20 0 0 347 1108' 
                        + ' A 75 50 0 0 1 283 1075'
                        } 
                    fill={'#C8CD04'} stroke={'#none'} strokeWidth={'2'}/>



                    <circle id={'htmlCircle'} cx={"484"} cy={"1230"} r="40" stroke="none" fill="#AE75C6" />
                    <FaHtml5 id={'html'} x={'450'} y={'1200' } style={{fontSize: '70', fill: '#EAE2DA'}}/>
                    <animate href={"#htmlCircle"}
                        attributeName={"cy"}
                        from={"1230"} to={"1230"} 
                        values="1230; 1233; 1237; 1240; 1237; 1233; 1230;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0s"} repeatCount={"indefinite"}
                    />
                    <animate href={"#html"}
                        attributeName={"y"}
                        from={"1200"} to={"1200"} 
                        values="1200; 1203; 1207; 1210; 1207; 1203; 1200;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0s"} repeatCount={"indefinite"}
                    />

                    
                    <circle id={'cssCircle'} cx={"370"} cy={"1070"} r="40" stroke="none" fill="#AE75C6" />
                    <FaCss3 id={'css'} x='340' y='1040' style={{fontSize: '70', fill: '#EAE2DA'}}/>
                    <animate href={"#cssCircle"}
                        attributeName={"cy"}
                        from={"1070"} to={"1066"} 
                        values="1070; 1069; 1067; 1066; 1067; 1069; 1070;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0s"} repeatCount={"indefinite"}
                    />
                    <animate href={"#css"}
                        attributeName={"y"}
                        from={"1040"} to={"1036"} 
                        values="1040; 1039; 1037; 1036; 1037; 1039; 1040;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0s"} repeatCount={"indefinite"}
                    />




                    <circle id={'jsCircle'} cx={"365"} cy={"1225"} r="40" stroke="none" fill="#AE75C6" />
                    <FaJs id={'js'} x='330' y='1190' style={{fontSize: '70', fill: '#EAE2DA'}}/>
                    <animate href={"#jsCircle"}
                        attributeName={"cy"}
                        from={"1225"} to={"1225"} 
                        values="1225; 1224; 1221; 1220; 1221; 1224; 1225;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0.7s"} repeatCount={"indefinite"}
                    />
                    <animate href={"#js"}
                        attributeName={"y"}
                        from={"1190"} to={"1190"} 
                        values="1190; 1189; 1186; 1185; 1186; 1189; 1190;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0.7s"} repeatCount={"indefinite"}
                    />






                    <circle id={'rubyCircle'} cx={"268"} cy={"1230"} r="40" stroke="none" fill="#AE75C6" />
                    <DiRuby id={'ruby'} x='230' y='1190' style={{fontSize: '70', fill: '#EAE2DA'}}/>
                    <animate href={"#rubyCircle"}
                        attributeName={"cy"}
                        from={"1230"} to={"1230"} 
                        values="1230; 1229; 1226; 1225; 1226; 1229; 1230;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />
                    <animate href={"#ruby"}
                        attributeName={"y"}
                        from={"1190"} to={"1190"} 
                        values="1190; 1189; 1186; 1185; 1186; 1189; 1190;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />




                    <circle id={'postCircle'} cx={"425"} cy={"1320"} r="40" stroke="none" fill="#AE75C6" />
                    <SiPostgresql id={'post'} x='390' y='1290' style={{fontSize: '70', fill: '#EAE2DA'}}/>
                    <animate href={"#postCircle"}
                        attributeName={"cy"}
                        from={"1320"} to={"1320"} 
                        values="1320; 1318; 1316; 1314; 1316; 1318; 1320;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />
                    <animate href={"#post"}
                        attributeName={"y"}
                        from={"1290"} to={"1290"} 
                        values="1290; 1288; 1286; 1284; 1286; 1288; 1290;"
                        keyTimes="0; 0.2; 0.3; 0.5; 0.7; 0.8; 1"
                        dur={"1s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />




                    <circle id={'railsCircle'} cx={"434"} cy={"1140"} r="40" stroke="none" fill="#AE75C6" />
                    <SiRails id={'rails'} x='399' y='1100' style={{fontSize: '70', fill: '#EAE2DA'}}/>
                    <animate href={"#railsCircle"}
                        attributeName={"cy"}
                        from={"1140"} to={"1140"} 
                        values="1140; 1139; 1135; 1134; 1135; 1139; 1140;"
                        keyTimes="0; 0.15; 0.35; 0.5; 0.65; 0.85; 1"
                        dur={"1.4s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />
                    <animate href={"#rails"}
                        attributeName={"y"}
                        from={"1100"} to={"1100"} 
                        values="1100; 1099; 1095; 1094; 1095; 1099; 1100;"
                        keyTimes="0; 0.15; 0.35; 0.5; 0.65; 0.85; 1"
                        dur={"1.4s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />
                    


                    <circle id={'reactCircle'} cx={"305"} cy={"1315"} r="40" stroke="none" fill="#AE75C6" />
                    <SiReact id={'react'} x='270' y='1280' style={{fontSize: '70', fill: '#EAE2DA'}}/>
                    <animate href={"#reactCircle"}
                        attributeName={"cy"}
                        from={"1315"} to={"1315"} 
                        values="1315; 1316; 1319; 1320; 1319; 1316; 1315;"
                        keyTimes="0; 0.15; 0.35; 0.5; 0.65; 0.85; 1"
                        dur={"1.6s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />
                    <animate href={"#react"}
                        attributeName={"y"}
                        from={"1280"} to={"1280"} 
                        values="1280; 1281; 1284; 1285; 1284; 1281; 1280;"
                        keyTimes="0; 0.15; 0.35; 0.5; 0.65; 0.85; 1"
                        dur={"1.6s"} begin={"0.5s"} repeatCount={"indefinite"}
                    />
                </svg>


            </div>

        </div>

    )

}


export default About